import { NotFound } from 'components/NotFound/NotFound'
import { PledgeAccordion } from 'components/PledgeAccordion/PledgeAccordion'
import { useContractStore } from 'context/ContractStore'
import { getFomattedDate, getFullValue } from 'lib/utils'
import React, { memo } from 'react'

/*const collateralClientData = data => {
  if (!data) return []
  return [
    { label: 'ФИО', value: getFullName(data?.firstName, data?.lastName, data?.patronymic) || 'Нет данных' },
    { label: 'ИНН', value: data?.iin || 'Нет данных' },
    {
      label: 'Дата рождения',
      value: data?.birthDate ? getFomattedDate(data?.birthDate) : 'Нет данных'
    },
    { label: 'Мобильный телефон', value: data?.mobilePhone1?.toString()?.toPhone() || 'Нет данных' },
    { label: 'Пол', value: data?.sexName?.name || 'Нет данных' },
    { label: 'Страна гражданства', value: data?.citizenship || 'Нет данных' },
    { label: 'Тип документа', value: data?.documentType?.name || 'Нет данных' },
    { label: 'Резиденство', value: data?.resident ? 'Резидент' : 'Нерезидент' },
    { label: 'Образование', value: data?.education?.name || 'Нет данных' },
    { label: 'Серия документа', value: data?.documentSeries || 'Нет данных' },
    { label: 'Номер документа', value: data?.documentNumber || 'Нет данных' },
    { label: 'Орган выдачи', value: data?.documentIssuer || 'Нет данных' },
    {
      label: 'Дата выдачи',
      value: data?.documentIssueDate ? getFomattedDate(data?.documentIssueDate) : 'Нет данных'
    },
    {
      label: 'Срок действия документа',
      value: data?.documentExpiryDate ? getFomattedDate(data?.documentExpiryDate) : 'Нет данных'
    },
    { label: 'Семейное положение', value: data?.maritalStatus?.name || 'Нет данных' },
    { label: 'Количество иждивенцев', value: data?.numberOfDependents?.toString() || 'Нет данных' },
    { label: 'Тип клиента', value: data?.clientType || 'Нет данных' }
  ]
}*/

const getRequiredData = data => {
  const type = data?.type
  switch (type) {
    case 'CLIENT':
      return [
        {
          label: 'Мобильный телефон 1',
          value: data?.clientGuarantee?.mobilePhone1?.toString()?.toPhone() || 'Нет данных'
        },
        {
          label: 'Мобильный телефон 2',
          value: data?.clientGuarantee?.mobilePhone2?.toString()?.toPhone() || 'Нет данных'
        },
        { label: 'Email', value: data?.clientGuarantee?.email || 'Нет данных' },
        { label: 'Вид деятельности', value: data?.clientGuarantee?.activityType || 'Нет данных' },
        { label: 'Название организации', value: data?.clientGuarantee?.organizationName || 'Нет данных' },
        { label: 'Должность', value: data?.clientGuarantee?.position || 'Нет данных' },
        { label: 'Позиция должности', value: data?.clientGuarantee?.jobLevel || 'Нет данных' },
        {
          label: 'Общий ежемесячный доход',
          value: data?.clientGuarantee?.monthlyIncome?.toString()?.thousandSeparator() || 'Нет данных'
        },
        {
          label: 'Стаж работы в организации (мес)',
          value: data?.clientGuarantee?.employmentDuration?.toString() || 'Нет данных'
        },
        { label: 'Общий стаж работы', value: data?.clientGuarantee?.totalExperience?.toString() || 'Нет данных' },
        { label: 'Рабочий телефон', value: data?.clientGuarantee?.workPhone?.toString()?.toPhone() || 'Нет данных' },
        {
          label: 'Сумма пенсии',
          value: data?.clientGuarantee?.pensionAmount?.toString()?.thousandSeparator() || 'Нет данных'
        }
      ]
    case 'CAR':
      return [
        { label: 'Группа', value: data?.group || 'Нет данных' },
        { label: 'Автосалон', value: data?.dealership || 'Нет данных' },
        { label: 'Первоначальный взнос %', value: data?.downPaymentPercentage || 'Нет данных' },
        {
          label: 'Первоначальный взнос тенге',
          value: data?.downPaymentAmount?.toString()?.thousandSeparator() || 'Нет данных'
        },
        { label: 'Сумма займа по авто', value: data?.loanAmount?.toString()?.thousandSeparator() || 'Нет данных' },
        { label: 'Марка', value: data?.brand || 'Нет данных' },
        { label: 'Модель', value: data?.model || 'Нет данных' },
        { label: 'Год выпуска', value: data?.yearOfManufacture || 'Нет данных' },
        { label: 'Цвет', value: data?.color || 'Нет данных' },
        { label: 'Кузов', value: data?.body || 'Нет данных' },
        { label: 'Страна производителя', value: data?.manufacturerCountry || 'Нет данных' },
        { label: 'Электромобиль', value: data?.electricCar ? 'Да' : 'Нет' },
        { label: 'Стоимость авто', value: data?.collateralValue?.toString()?.thousandSeparator() || 'Нет данных' },
        {
          label: 'Стоимость подключения GPS',
          value: data?.gpsConnection?.toString()?.thousandSeparator() || 'Нет данных'
        },
        {
          label: 'Сумма страхового покрытия',
          value: data?.insurancePrice?.toString()?.thousandSeparator() || 'Нет данных'
        },
        {
          label: 'Общая сумма кредита',
          value: data?.totalLoanAmount?.toString()?.thousandSeparator() || 'Нет данных'
        },
        {
          label: 'Расходы на регистрацию автомобиля',
          value: data?.carRegistrationCosts?.toString()?.thousandSeparator() || 'Нет данных'
        }
      ]
    case 'REAL_ESTATE':
      return [
        { label: 'Тип недвижимости', value: data?.propertyType || 'Нет данных' },
        { label: 'Общая площадь', value: data?.totalArea || 'Нет данных' },
        { label: 'Жилая площадь', value: data?.livingArea || 'Нет данных' },
        { label: 'Материал стен', value: data?.wallMaterial || 'Нет данных' },
        { label: 'Год постройки', value: data?.buildingYear || 'Нет данных' },
        {
          label: 'Дата и номер регистрации',
          value: data?.registrationDateAndNumber || 'Нет данных'
        },
        { label: 'Кадастровый номер', value: data?.cadastreNumber || 'Нет данных' },
        { label: 'Акт на право частной', value: data?.rightAct || 'Нет данных' }
      ]
    case 'LEGAL_CLIENT':
      return []
    default:
      return []
  }
}
const getAdditionalData = data => {
  const type = data?.type
  switch (type) {
    case 'CLIENT':
      return [
        { label: 'Страна', value: data?.clientGuarantee?.country?.name || 'Нет данных' },
        { label: 'Область', value: data?.clientGuarantee?.region || 'Нет данных' },
        { label: 'Район', value: data?.clientGuarantee?.district || 'Нет данных' },
        { label: 'Сельский округ', value: data?.clientGuarantee?.ruralArea || 'Нет данных' },
        { label: 'Населённый пункт', value: data?.clientGuarantee?.settlement || 'Нет данных' },
        { label: 'Улица/Микрорайон', value: data?.clientGuarantee?.street || 'Нет данных' },
        { label: 'Дом', value: data?.clientGuarantee?.houseNumber || 'Нет данных' },
        { label: 'Квартира', value: data?.clientGuarantee?.apartment || 'Нет данных' },
        { label: 'Code KATO', value: data?.clientGuarantee?.katoCode || 'Нет данных' },
        {
          label: 'Адрес',
          value: getFullValue(
            data?.clientGuarantee?.country?.name,
            data?.clientGuarantee?.region,
            data?.clientGuarantee?.district,
            data?.clientGuarantee?.street,
            data?.clientGuarantee?.houseNumber
          )
        }
      ]
    case 'CAR':
      return [
        {
          label: 'Дата заключения Kasko',
          value: data?.cascoStartDate ? getFomattedDate(data?.cascoStartDate) : 'Нет данных'
        },
        { label: 'Kasko страхование по годам', value: data?.cascoInsuranceYears || 'Нет данных' },
        {
          label: 'Дата истечения Kasko',
          value: data?.cascoEndDate ? getFomattedDate(data?.cascoEndDate) : 'Нет данных'
        },
        { label: 'Страхование клиента по годам', value: data?.clientInsuranceYears || 'Нет данных' },
        {
          label: 'Дата заключения страхования',
          value: data?.clientInsuranceStartDate ? getFomattedDate(data?.clientInsuranceStartDate) : 'Нет данных'
        },
        {
          label: 'Дата истечения страхования',
          value: data?.clientInsuranceEndDate ? getFomattedDate(data?.clientInsuranceStartDate) : 'Нет данных'
        },
        { label: 'Гос. номер', value: data?.licensePlate || 'Нет данных' },
        { label: 'Свидетельство регистрации ТС', value: data?.registrationCertificate || 'Нет данных' },
        {
          label: 'Дата регистрации ТС',
          value: data?.registrationDate ? getFomattedDate(data?.registrationDate) : 'Нет данных'
        },
        { label: 'VIN', value: data?.vinNumber || 'Нет данных' },
        { label: 'Пробег', value: data?.mileage || 'Нет данных' },
        {
          label: 'Номер ДКП',
          value: ['', '____________', undefined, null].includes(data?.dkpNumber) ? 'Нет данных' : data?.dkpNumber
        },
        {
          label: 'Дата ДКП',
          value: ['', '__.__.____', undefined, null].includes(getFomattedDate(data?.dkpDate))
            ? 'Нет данных'
            : getFomattedDate(data?.dkpDate)
        }
      ]
    case 'REAL_ESTATE':
      return [
        { label: 'Область', value: data?.region || 'Нет данных' },
        { label: 'Город', value: data?.city || 'Нет данных' },
        { label: 'Район', value: data?.district || 'Нет данных' },
        { label: 'Микрорайон', value: data?.microdistrict || 'Нет данных' },
        { label: 'Улица', value: data?.street || 'Нет данных' },
        { label: 'Номер дома', value: data?.houseNumber || 'Нет данных' },
        { label: 'Кадастровый номер', value: data?.cadastreNumber || 'Нет данных' },
        { label: 'Общая площадь', value: data?.totalArea || 'Нет данных' },
        { label: 'Жилая площадь', value: data?.livingArea || 'Нет данных' },
        { label: 'Материал стен', value: data?.wallMaterial || 'Нет данных' },
        { label: 'Год постройки', value: data?.buildingYear || 'Нет данных' },
        { label: 'Количество комнат', value: data?.numberOfRooms || 'Нет данных' },
        { label: 'Этаж', value: data?.floor || 'Нет данных' },
        { label: 'Общее количество этажей', value: data?.totalFloors || 'Нет данных' },
        { label: 'Площадь земельного участка', value: data?.landPlotArea || 'Нет данных' },
        { label: 'Целевое назначение земельного участка', value: data?.landPurpose || 'Нет данных' },
        {
          label: 'Дата регистрации',
          value: data?.registrationDate ? getFomattedDate(data?.registrationDate) : 'Нет данных'
        },
        { label: 'Дата и номер регистрации', value: data?.registrationDateAndNumber || 'Нет данных' },
        { label: 'Акт на право собственности', value: data?.ownershipAct || 'Нет данных' }
      ]
    case 'LEGAL_CLIENT':
      return []
    default:
      return []
  }
}

export const getCollateralsData = (data, readonly = false) => {
  return [
    /* TODO {
      title: 'Данные клиента',
      line: true,
      hasChip: true,
      edit: false,
      data: collateralClientData(data?.clientGuarantee)
    },*/
    {
      title: 'Обязательная информация',
      line: true,
      edit: false,
      data: getRequiredData(data)
    },
    {
      title: 'Дополнительная информация',
      line: true,
      edit: !readonly,
      data: getAdditionalData(data)
    }
  ]
}

export const CollateralTab = memo(({ page, readonly = false }) => {
  const {
    contractStore: { loanApplicationData, collateral }
  } = useContractStore()

  const collaterals = (loanApplicationData?.collaterals || []).filter(item => item.type !== 'CLIENT')

  if (page !== 'collateral' && !collaterals?.length) {
    return <NotFound title="Нет залога" />
  }
  return (
    <>
      {page === 'collateral' && (
        <PledgeAccordion
          sections={getCollateralsData(collateral)}
          data={collateral}
          columns="4"
          collateralFiles={loanApplicationData?.collateralFiles}
          readonly={readonly}
        />
      )}
      {page !== 'collateral' &&
        (collaterals || [])?.map((item, index) => (
          <PledgeAccordion
            key={index}
            sections={getCollateralsData(item)}
            data={item}
            index={index}
            isEdit="collateral"
            readonly={readonly}
          />
        ))}
    </>
  )
})
